import { Blockquote } from '@ui';
import { cx } from 'class-variance-authority';
import Image from 'next/image';
import useMediaQuery from '../hooks/useMediaQuery';

const SportisionAppBookingAd = ({ className, small: _small }: { small?: true; className?: string }) => {
    const isMobile = useMediaQuery('(max-width: 650px)');
    const small = isMobile || _small;

    return (
        <Blockquote
            color="success"
            className={cx(
                className,
                'tw-flex tw-flex-col tw-items-center md:tw-flex-row',
                small ? '!md:tw-py-1 !tw-px-4 !tw-py-4' : '!md:tw-py-1 !tw-px-6 !tw-py-6'
            )}
        >
            <div className="tw-w-full tw-flex-1">
                <h2 className={cx(small && '!tw-text-base', 'tw-font-semibold')}>
                    Du hast noch nicht die neue Sportision App?
                </h2>
                <h5 className={cx(small && 'tw-text-xs')}>
                    Lade sie jetzt kostenlos herunter und buche dein Sporterlebnis noch einfacher und schneller!
                </h5>
            </div>
            <div
                className={cx(
                    small ? 'md:tw-ml-4 md:tw-flex-col' : 'tw-flex-col md:tw-ml-8',
                    'tw-relative tw-mt-4 tw-flex tw-w-full tw-items-center tw-justify-around tw-gap-4 md:tw-mt-0 md:tw-w-auto md:tw-items-end'
                )}
            >
                <div
                    className={cx(
                        'tw-relative tw-aspect-[2142/720]',
                        small ? 'tw-h-[36px] md:tw-h-[50px]' : 'tw-h-[50px] md:tw-h-[60px]'
                    )}
                >
                    <a target="_blank" href="https://apps.apple.com/us/app/sportision/id6476008864">
                        <Image alt="" src={'/images/app/app-store.png'} layout="fill" objectFit="contain" />
                    </a>
                </div>
                <div
                    className={cx(
                        'tw-relative tw-aspect-[2691/796]',
                        small ? 'tw-h-[36px] md:tw-h-[50px]' : 'tw-h-[50px] md:tw-h-[60px]'
                    )}
                >
                    <a target="_blank" href="https://play.google.com/store/apps/details?id=de.sportision.app">
                        <Image alt="" src={'/images/app/google-play.png'} layout="fill" objectFit="contain" />
                    </a>
                </div>
            </div>
        </Blockquote>
    );
};

export default SportisionAppBookingAd;
